import { render } from "./newBookmark.vue?vue&type=template&id=79a0b86e"
import script from "./newBookmark.vue?vue&type=script&lang=js"
export * from "./newBookmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__